function fadeInSection(domElement) {
    const isVisible = false;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                domElement.classList.add('is-visible');
            }
        });
    });

    observer.observe(domElement);

    return {
        destroy: () => {
            observer.disconnect();
        },
    };
}

// Beispielaufruf:
const targetElements = document.getElementsByClassName('fade-in-section');

// Iteriere durch die HTMLCollection und wende fadeInSection auf jedes Element an
Array.from(targetElements).forEach((element) => {
    const fadeInInstance = fadeInSection(element);
});
